import React, { Component } from 'react';
import * as Styles from './Styles';

type Props = {};

type State = {};

class Info extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.Container>
					<Styles.TopContainer>
						<p>informacje o rozpatrywanej sprawie</p>
						<p>można uzyskać na różne sposoby</p>
					</Styles.TopContainer>
					<Styles.BottomContainer>
						<Styles.BottomLeft>
							<div>
								<Styles.TopFont>
									ubezpieczenie OC, kosztów ochrony prawnej,
									NNW
								</Styles.TopFont>
								<Styles.SmallFont
									style={{ marginTop: '-16px' }}
								>
									mailowo wysyłając wiadomość na adres:
								</Styles.SmallFont>
								<Styles.BigFont borderColor="#F8F96F">
									<span>brokerszkody@ergohestia.pl </span>
								</Styles.BigFont>
								<Styles.SmallFont style={{ marginBottom: '0' }}>
									Pamiętaj, aby w tytule oraz treści
									wiadomości e-mail podać numer szkody lub
									sprawy.
								</Styles.SmallFont>
								<Styles.SmallFont
									style={{
										marginTop: '16px',
										marginBottom: '0',
										color: '#fff',
										fontSize: '16px',
										fontWeight: '600',
									}}
								>
									telefonicznie pod nr infolinii STU ERGO
									Hestia:
								</Styles.SmallFont>
								<Styles.SmallFont
									style={{
										marginTop: '0px',
										marginBottom: '0',
										color: '#fff',
										fontSize: '20px',
										fontFamily: 'Montserrant-Black',
									}}
								>
									<a
										href="tel:801 107 107"
										style={{ color: '#fff' }}
									>
										801 107 107
									</a>{' '}
									lub{' '}
									<a
										href="tel:58 555 55 55"
										style={{ color: '#fff' }}
									>
										58 555 55 55
									</a>
								</Styles.SmallFont>
								<Styles.SmallFont
									style={{
										marginTop: '16px',
										marginBottom: '0',
									}}
								>
									Przygotuj numer szkody oraz numer PESEL
								</Styles.SmallFont>
								<Styles.SmallFont style={{ marginTop: '4px' }}>
									Pozostałe formy kontaktu z ERGO Hestią
									znajdziesz{' '}
									<a href="https://www.ergo-hestia-warszawa.pl/zgloszenie-szkody">
										tutaj
									</a>
									.
								</Styles.SmallFont>
							</div>
						</Styles.BottomLeft>
						<Styles.BottomRight>
							<div>
								<Styles.TopFont>
									ubezpieczenie Assistance
								</Styles.TopFont>
								<Styles.SmallFont
									style={{ marginTop: '-16px' }}
								>
									mailowo wysyłając wiadomość na adres:
								</Styles.SmallFont>
								<Styles.BigFont borderColor="#05A6ED">
									<span>
										pms.szkody@mondial-assistance.pl
									</span>
								</Styles.BigFont>
								<Styles.SmallFont style={{ marginBottom: '0' }}>
									Pamiętaj, aby w tytule oraz treści
									wiadomości e-mail podać numer szkody lub
									sprawy.
								</Styles.SmallFont>
								<Styles.SmallFont
									style={{
										marginTop: '16px',
										marginBottom: '0',
										color: '#fff',
										fontSize: '16px',
										fontWeight: '600',
									}}
								>
									telefonicznie pod nr Centrum Alarmowego:
								</Styles.SmallFont>
								<Styles.SmallFont
									style={{
										marginTop: '0',
										marginBottom: '0',
										color: '#fff',
										fontSize: '20px',
										fontFamily: 'Montserrant-Black',
									}}
								>
									<a
										href="tel:22 522 29 90"
										style={{ color: '#fff' }}
									>
										22 522 29 90
									</a>{' '}
									lub{' '}
									<a
										href="tel:22 232 29 90"
										style={{ color: '#fff' }}
									>
										22 232 29 90
									</a>
								</Styles.SmallFont>
								<Styles.SmallFont
									style={{
										marginTop: '16px',
										marginBottom: '0',
									}}
								>
									Przygotuj numer szkody oraz numer PESEL
								</Styles.SmallFont>
								<Styles.SmallFont style={{ marginTop: '4px' }}>
									Pozostałe formy kontaktu z ERGO Hestią
									znajdziesz{' '}
									<a href="https://www.ergo-hestia-warszawa.pl/zgloszenie-szkody">
										tutaj
									</a>
									.
								</Styles.SmallFont>
							</div>
						</Styles.BottomRight>
					</Styles.BottomContainer>
				</Styles.Container>
			</Styles.Wrapper>
		);
	}
}

export default Info;
